"use client";
import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { Root as v, Trigger as y, Portal as b, Content as k, Arrow as C } from "@radix-ui/react-tooltip";
import { Provider as _ } from "@radix-ui/react-tooltip";
import { forwardRef as O, useState as T, useEffect as N } from "react";
import { twMerge as W } from "tailwind-merge";
import { RichText as z } from "./index.es6.js";
import { Text as f } from "./index.es4.js";
function M() {
  try {
    return matchMedia("(hover: hover)").matches;
  } catch {
    return !0;
  }
}
const R = O(
  ({
    className: i = "",
    contentProps: d = {},
    description: a,
    descriptionHtml: n,
    hasArrow: u = !0,
    title: r,
    trigger: m,
    variant: l = "dark",
    triggerProps: s = {},
    ...e
  }, x) => {
    const [o, h] = T(!1);
    N(() => {
      e != null && e.defaultOpen && h(!0);
    }, [e == null ? void 0 : e.defaultOpen]);
    const g = W(
      `rounded shadow-level1-soft p-3 z-[1050] ${l === "light" ? "bg-white text-black" : "bg-black text-white"}`,
      i
    ), w = a || n ? "semibold" : "regular";
    return M() || (e = {
      ...e,
      open: o,
      onOpenChange: () => h(!1)
    }, s = {
      ...s,
      onClick: () => h(!0)
    }), /* @__PURE__ */ c(v, { delayDuration: 0, ...e, children: [
      /* @__PURE__ */ t(y, { ref: x, asChild: !0, ...s, children: m }),
      (r || a || n) && /* @__PURE__ */ t(b, { children: /* @__PURE__ */ c(
        k,
        {
          "data-testid": "tooltip-content",
          className: g,
          sideOffset: 4,
          hideWhenDetached: !0,
          ...d,
          children: [
            u && /* @__PURE__ */ t(
              C,
              {
                className: `fill-current drop-shadow-level1-soft mask-clip ${l === "light" ? "text-white" : "text-black"}`,
                style: { clipPath: "inset(0 -10px -10px -10px)" }
              }
            ),
            /* @__PURE__ */ c("div", { className: "flex flex-col gap-y-1.5 max-w-xs", children: [
              r && /* @__PURE__ */ t(f, { fontSize: "sm", fontWeight: w, asChild: !0, children: /* @__PURE__ */ t("span", { children: r }) }),
              n ? /* @__PURE__ */ t(
                z,
                {
                  content: n,
                  className: "text-xs [&_*]:text-xs",
                  fontFamily: l === "light" ? "polysans" : "inter"
                }
              ) : a ? /* @__PURE__ */ t(f, { fontSize: "xs", fontWeight: "regular", children: a }) : null
            ] })
          ]
        }
      ) })
    ] });
  }
);
R.displayName = "Tooltip";
export {
  R as Tooltip,
  _ as TooltipProvider
};
